import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import CustomSelect from "./CustomSelect";


import useToken from "./useToken";
import { buildIntroPath } from "./introNavigation";

import { useTranslation } from "react-i18next";



const GameConfigPage = (props) => {
  const [loading, setLoading] = useState(false);
  const [numberPlayer, setNumberPlayer] = useState(6);
  const [additionalHappening, setAdditionalHappening] = useState(true);
  const [displayIndicators, setDisplayIndicators] = useState(true);
  const [workshopName, setWorkshopName] = useState("");
  const [workshopType, setWorkshopType] = useState("grand_public");
  const [workshopConfig, setWorkshopConfig] = useState(null);
  const [bassin, setBassin] = useState("rhone");
  const [includeClient, setIncludeClient] = useState("");
  const [workshopConfigList, setWorkshopConfigList] = useState([]);
  const [realParticipants, setRealParticipants] = useState("");
  const [nbRounds, setNbRounds] = useState(5);
  const [canChooseRounds, setCanChooseRounds] = useState(false);

  const language = props.language || "fr";
  const { t, i18n } = useTranslation();


  const { token } = useToken();



  const options = [
    { label: "4 "+t("actors"), value: 4 },
    { label: "5 "+t("actors"), value: 5 },
    { label: "6 "+t("actors"), value: 6 },
    { label: "7 "+t("actors"), value: 7 },
    { label: "8 "+t("actors"), value: 8 },
    { label: "9 "+t("actors"), value: 9 },
    { label: "10 "+t("actors"), value: 10 },
  ];

  const workshopTypes = [
    { label: t("general-public"), value: "grand_public" },
    { label: t("company"), value: "entreprise" },
    { label: t("association"), value: "association" },
    { label: t("private-circle"), value: "prive" },
    { label: t("community"), value: "collectivite" },
    { label: t("higher-education"), value: "enseignement_superieur" },
    { label: t("test"), value: "test" },
  ];

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);



  useEffect(() => {
    // Fonction pour récupérer les configurations depuis l'API
    const fetchWorkshopConfigs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/game_config_list`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          }
        });
        const data = await response.json();
        console.log(data)
        const formattedConfigs = data.map((config) => ({
          label: config.name, 
          value: config._id,
          language: config.language, 
          ...config  
        }));
        console.log(formattedConfigs)

        setWorkshopConfigList(formattedConfigs);  // Met à jour l'état avec la liste formatée
      } catch (error) {
        console.error('Erreur lors du chargement des configurations:', error);
      }
    };

    const fetchProfile = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
          headers: { Authorization: "Bearer " + token },
        });
        const data = await response.json();
        setCanChooseRounds(data.can_choose_rounds ?? false);
      } catch (error) {
        console.error('Erreur lors du chargement du profil:', error);
      }
    };

    fetchWorkshopConfigs();
    fetchProfile();
  }, []);

  const navigate = useNavigate();

  const handleTitleChange = (event) => {
    setWorkshopName(event.target.value);
  };

  const handleActorChange = (selectedOption) => {
    setNumberPlayer(selectedOption.value);
  };

  const handleWorkshopTypeChange = (selectedOption) => {
    setWorkshopType(selectedOption.value);
  };

  const handleWorkshopConfigChange = (selectedOption) => {
    setWorkshopConfig(selectedOption);
  }

  const handleAdditionalHappeningChange = () => {
    setAdditionalHappening(!additionalHappening);
  };

  const handleDisplayIndicatorsChange = () => {
    setDisplayIndicators(!displayIndicators);
  };

  const handleRealParticipantsChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) { // Allow only positive integers
      setRealParticipants(value);
    }
  };

  const handleSubmit = async (startNow) => {
    if (!workshopConfig) return;
    setLoading(true);
    const dataReceive = {
      number_player: numberPlayer,
      show_happening: additionalHappening,
      show_additional_score: displayIndicators,
      workshop_name: workshopName,
      status: "not started",
      type: workshopType,
      include_client: includeClient, 
      bassin: bassin,
      game_config: workshopConfig._id,
      number_participants: parseInt(realParticipants) || 0, // Ensure it's a number
      nb_rounds: nbRounds,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/newgame`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token,
        },
        body: JSON.stringify(dataReceive),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      console.log("response", responseData);
      const gameId = responseData.game_id;

      navigate(
        buildIntroPath(gameId, {
          gameConfigId: workshopConfig._id,
          language: workshopConfig.language,
          tutoUrl: workshopConfig.custom_intro_video,
          customIntro: workshopConfig.custom_intro,
          bassin: workshopConfig.bassin_intro,
        })
      );
    
    } catch (error) {
      setLoading(false);
      console.error("Error posting data:", error);
    }
  };

  return (
    <Fragment>
      {loading ? (
        <div className="loader-container">
          <img src="./loader.gif" className="loader" />
        </div>
      ) : (
        <div className="game-config">
          <div className="header_selection_container">
            <h1 className="home-title">{t("game-configuration")}</h1>
            <div className="form-group">
              <div className="num_actor_text">
                {t("selected-actors", {numberPlayer : numberPlayer})}
              </div>
            </div>
          </div>
          <div className="form-container">
            <div className="additional_game_selection_container">
              <div className="input-label">{t("workshop-name")} : </div>
              <input
                placeholder={t("demo-workshop")}
                value={workshopName}
                onChange={handleTitleChange}
                className="input"
              />
            </div>

            <div className="additional_game_selection_container">
              <div className="input-label">{t("number-of-actors")} :</div>
              <CustomSelect
                options={options}
                onSelect={handleActorChange}
                defaultValue={{ label: "6 "+t("actors"), value: 6 }}
              />
            </div>
            {/* {numberPlayer !== 4 && (
              <div className="additional_game_selection_container">
                <div className="input-label">{t("including-client")}</div>
                <CustomSelect
                  options={[
                    { label: t("yes"), value: true },
                    { label: t("no"), value: false },
                  ]}
                  onSelect={(selectedOption) => setIncludeClient(selectedOption.value)}
                  defaultValue={{ label: t("no"), value: false }}
                />
              </div>
            )} */}

            <div className="additional_game_selection_container">
              <div className="input-label" style={{ fontWeight: 700 }}>
                {t("workshop-configuration")}
                <span style={{ color: "#db6c52", marginLeft: 4 }}>*</span>
                {!workshopConfig && (
                  <span style={{ color: "#db6c52", fontSize: 12, fontWeight: 400, marginLeft: 8 }}>
                    - champ requis
                  </span>
                )}
              </div>
              <CustomSelect
                options={workshopConfigList}
                onSelect={handleWorkshopConfigChange}
                placeholder={t("Sélectionner une configuration...")}
              />
            </div>


            <div className="additional_game_selection_container">
              <div className="input-label">{t("audience-type")} : </div>
              <CustomSelect
                options={workshopTypes}
                onSelect={handleWorkshopTypeChange}
                defaultValue={{ label: t("general-public"), value: "grand_public" }}
              />
            </div>

            <div className="additional_game_selection_container">
              <div className="input-label">{t("real-number-participants")} :</div>
              <input
                type="text"
                placeholder={t("enter-a-number")}
                value={realParticipants}
                onChange={handleRealParticipantsChange}
                className="input"
              />
            </div>

            {canChooseRounds && (
              <div className="additional_game_selection_container">
                <div className="input-label">Nombre de tours :</div>
                <CustomSelect
                  options={[2, 3, 4, 5].map(n => ({ label: `${n} tours`, value: n }))}
                  onSelect={(opt) => setNbRounds(opt.value)}
                  defaultValue={{ label: "5 tours", value: 5 }}
                />
              </div>
            )}

            <div className="additional_game_selection_container">
              <div className="form-group">
                <div className="selector_container">
                  <div className="name">{t("show-scores")} : </div>
                  <label className="switch-button">
                    <input
                      type="checkbox"
                      checked={displayIndicators}
                      onChange={handleDisplayIndicatorsChange}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="selector_container">
                  <div className="name">{t("additional-happening")} :</div>
                  <label className="switch-button">
                    <input
                      type="checkbox"
                      checked={additionalHappening}
                      onChange={handleAdditionalHappeningChange}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>

              <div className="form-group center_element">
                <button
                  className="blue-button"
                  onClick={() => handleSubmit(true)}
                  disabled={!workshopConfig}
                  style={!workshopConfig ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                >
                  {t("create-and-play-now")}
                </button>
                {/* <button
                  className="blue-button"
                  onClick={() => handleSubmit(false)}
                >
                  Créer le jeu pour plus tard
                </button> */}
              </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default GameConfigPage;
